import ReviewField from "../ReviewField";
import SectionDocuments from "../SectionDocuments";

const BankSection = ({
  fields = [],
  formData,
  fieldFlags,
  flagModeEnabled,
  restrictToUpdatedFields,
  updatedFields,
  flagModal,
  focusedFlagKey,
  onOpenFlagModal,
  onUpdateField,
  documents = [],
  getFileIcon,
  onPreviewDoc,
}) => {
  const fieldProps = {
    sectionKey: "bank",
    formData,
    fieldFlags,
    flagModeEnabled,
    restrictToUpdatedFields,
    updatedFields,
    flagModal,
    focusedFlagKey,
    onOpenFlagModal,
    onUpdateField,
  };

  const nodes = [];
  for (let index = 0; index < fields.length; index += 1) {
    const field = fields[index];
    if (field?.type === "heading") {
      nodes.push(
        <div
          key={`bank-heading-break-${field.label}`}
          className="rr-flex-break"
          aria-hidden="true"
        />,
      );
      nodes.push(
        <div
          key={`bank-heading-${field.label}`}
          className={`rr-subsection-head${
            index === 0 ? " rr-subsection-head--first" : ""
          }`}
        >
          <div className="form-subhead">{field.label}</div>
        </div>,
      );
      continue;
    }
    nodes.push(
      <ReviewField key={field.key} {...fieldProps} field={field} />,
    );
  }

  return (
    <>
      <div className="flex flex-wrap">{nodes}</div>
      <SectionDocuments
        sectionKey="bank"
        documents={documents}
        getFileIcon={getFileIcon}
        onPreviewDoc={onPreviewDoc}
        fieldFlags={fieldFlags}
        flagModeEnabled={flagModeEnabled}
        restrictToUpdatedFields={restrictToUpdatedFields}
        updatedFields={updatedFields}
        flagModal={flagModal}
        focusedFlagKey={focusedFlagKey}
        onOpenFlagModal={onOpenFlagModal}
      />
    </>
  );
};

export default BankSection;
